export default {
    isEmpty
};

export function isEmpty(value) {
    return value === null || typeof value === "undefined";
}
